<div class="body-container">
  <div class="page-main">
    <div class="page-container">
      <!-- Next Bill Run -->
      <div class="page-section">
        <div class="page-section-head">
          <h1 class="typo subheading-1 fw400 semi-condensed label-title">Next Operation Date</h1>
        </div>
        <app-grid-bill-run (emitGetBillRunHistory)="billRunHistory.getBillRun()"></app-grid-bill-run>
      </div>
      <!-- Billing Operation History -->
      <div class="page-section">
        <div class="page-section-head">
          <h1 class="typo subheading-1 fw400 semi-condensed label-title">Operation History</h1>
        </div>
        <app-grid-bill-run-history #billRunHistory></app-grid-bill-run-history>
      </div>
    </div>
  </div>
</div>
